import type { FormValues, JsonValue } from '@funkit/connect-core'

import { looksLikeEmail } from '../sessionContact'
import type { StripeLinkRegistration } from './stripeOnramp'

/**
 * The account-creation round's answers as `registerLinkUser`'s argument, or
 * `undefined` when a required piece is missing.
 *
 * The email is not a form field: Link must be registered under the identity
 * the backend already verified, so the caller hands it over from the round's
 * transition rather than letting the buyer type it.
 */
export function stripeLinkRegistrationFrom(
  values: FormValues,
  verifiedEmail: string | undefined,
): StripeLinkRegistration | undefined {
  const email = text(verifiedEmail)
  const phone = text(values.PHONE_NUMBER)
  const country = text(values.RESIDENTIAL_ADDRESS_COUNTRY)
  if (
    email === undefined ||
    !looksLikeEmail(email) ||
    phone === undefined ||
    country === undefined
  ) {
    return undefined
  }
  // Stripe takes one name; the contract has no `fullName` id, so the two it
  // does have are joined. Omitted rather than sent blank when neither answered.
  const fullName = [text(values.LEGAL_FIRST_NAME), text(values.LEGAL_LAST_NAME)]
    .filter((part): part is string => part !== undefined)
    .join(' ')
  return { email, phone, country, ...(fullName === '' ? {} : { fullName }) }
}

function text(value: JsonValue | undefined): string | undefined {
  if (typeof value !== 'string') {
    return undefined
  }
  const trimmed = value.trim()
  return trimmed === '' ? undefined : trimmed
}
